import * as React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { NavLink as RouterNavLink } from 'react-router-relative-link';
import { Card, CardBody } from 'reactstrap';
import { compose, setDisplayName } from 'recompose';
import LoadingSpinner from '../../LoadingSpinner';
import withErrorPlaceholder from '../../withErrorPlaceholder';
import withLoadingPlaceholder from '../../withLoadingPlaceholder';
import { ActivityListProps } from '../types';
import './ActivityList.scss';
import ActivityListCard from './ActivityListCard';

export const LoadingPlaceholder: React.StatelessComponent<any> = (
    props: any
) => (
    <div className="activity-list-item" key="loading-placeholder">
        <Card className="ml-3 mb-3 activity-card">
            <CardBody>
                <LoadingSpinner key="loader" className="activity-list-loader" />
            </CardBody>
            <div className="activity-card-right p-4">
                <LoadingSpinner key="loader" className="activity-list-loader" />
            </div>
        </Card>
    </div>
);

export const ErrorPlaceholder = () => (
    <div className="card-list">
        <div className="activity-list-item" key="error-placeholder">
            <Card className="ml-3 mb-3 activity-card">
                <CardBody>
                    <p className="activity-list-error text-muted">
                        Error loading activities
                    </p>
                </CardBody>
            </Card>
        </div>
    </div>
);

const enhance = compose<ActivityListProps, ActivityListProps>(
    withErrorPlaceholder(ErrorPlaceholder),
    withLoadingPlaceholder(() => (
        <div className="card-list">
            <LoadingPlaceholder />
        </div>
    )),
    setDisplayName('ActivityList')
);

const ActivityList = ({
    activities,
    loading,
    error,
    prefetchActivity,
    pageInfo,
    handleFetchMore
}: ActivityListProps) => {
    if (!handleFetchMore) {
        throw new Error('No fetch-more function provided');
    }

    const loader = <LoadingPlaceholder key="loading-placeholder" />;

    return (
        <InfiniteScroll
            className="card-list"
            pageStart={0}
            loadMore={handleFetchMore}
            hasMore={pageInfo && pageInfo.hasMore}
            loader={loader}
            initialLoad={false}
            useWindow={true}
            threshold={1000}
        >
            {(activities || []).map(a => {
                const { id } = a;

                if (!id) {
                    throw new Error('No activity id specified');
                }

                const prefetch = () => prefetchActivity && prefetchActivity(id);
                return (
                    <RouterNavLink
                        key={id}
                        className="activity-list-item"
                        // Use a relative link to the activity, so this component
                        // can be used for both the demo and the user list
                        to={'./' + id}
                        onMouseOver={prefetch}
                    >
                        <ActivityListCard {...a} />
                    </RouterNavLink>
                );
            })}
        </InfiniteScroll>
    );
};

export default enhance(ActivityList);



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityListScene/ActivityList.tsx